import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Form, message, Modal, Select } from "antd";
import axios from "axios";
import { forwardRef, useImperativeHandle, useState } from "react";
import { hostname } from "../hooks/useEndeavour";

export const UserTagBindingModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const query = useQuery({
    queryKey: ["tag-list"],
    queryFn: () => {
      return axios
        .get(`${hostname}/pa-alliance/notification/tag`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status !== 200) {
            message.error("Failed to fetch tag list");
            return [];
          }

          let options = res.data.payload.map((item) => ({
            label: item,
            value: item,
          }));

          return options;
        });
    },
  });

  const submit = useMutation({
    mutationFn: (data) => {
      return axios
        .post(`${hostname}/pa-alliance/notification/user/tag`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status !== 200) {
            message.error("Add Fail");
          } else {
            message.success("Add Success");
            handleCancel(); // Close modal and reset form
            if (props.onChange) {
              props.onChange(); // Trigger parent component refresh
            }
          }
        })
        .catch((error) => {
          console.error("Error submitting user tag binding:", error);
          message.error("Add Fail");
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  const showModal = (email) => {
    setEmail(email);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  const onFinish = (values) => {
    setLoading(true);
    values.action = "create";
    values.users = [email];
    submit.mutate(values);
  };

  useImperativeHandle(
    ref,
    () => ({
      showModal,
    }),
    []
  );

  return (
    <Modal title="User & Tag Combination" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name={"tag"} label="Tags" rules={[{ required: true }]}>
          <Select mode="tags" options={query.data} />
        </Form.Item>

        <Button htmlType="submit" block loading={loading} type="primary">
          Create
        </Button>
      </Form>
    </Modal>
  );
});
